import VotingRegistrationsService from '../services/VotingRegistrationsService';

const helper = {
  mapRegistration(registration, votersCount) {
    const newProp = {
      status: {
        code: registration.status?.toLowerCase(),
      },
      location: registration.votingMember?.residentialAddress?.suburb,
    };
    if (registration.company && registration.company.physicalAddress) {
      newProp.location = registration.company.physicalAddress.suburb;
    } else if (registration.person && registration.person.postalAddress) {
      newProp.location = registration.person.postalAddress.suburb;
    }
    switch (registration.status) {
      case 'Submitted':
        newProp.status.name = 'Awaiting Data Verification';
        newProp.detailedStatus = 'Pending Data Verification';
        break;
      case 'Verified':
        newProp.status.name = 'Pending Approval';
        break;
      case 'Approved':
        newProp.status.name = registration.status;
        break;
      case 'Denied':
        newProp.status.name = registration.status;
        break;
      default:
        newProp.status.name = registration.status;
        newProp.detailedStatus = registration.status;
    }
    if (registration.status !== 'Submitted') {
      const approvedCount = registration.userActions?.filter((ua) => ua.action === 'Approve').length || 0;
      const deniedCount = registration.userActions?.filter((ua) => ua.action === 'Deny').length || 0;
      const pendingCount = votersCount - approvedCount - deniedCount;
      newProp.detailedStatus = `Approval: ${approvedCount} Yes | ${deniedCount} No | ${pendingCount} Pending`;
    }
    switch (registration.type) {
      case 'plumber':
        newProp.typeName = 'Plumbers';
        break;
      case 'retired':
        newProp.typeName = 'Retired Plumbers';
        break;
      case 'teacher':
        newProp.typeName = 'Teaching';
        break;
      case 'associate':
        newProp.typeName = 'Associates';
        break;
      default:
        newProp.typeName = registration.type ? registration.type.charAt(0).toUpperCase() + registration.type.slice(1) : '-';
    }
    if (registration.statusLog?.Submitted) {
      newProp.submittedDate = new Date(registration.statusLog.Submitted).toLocaleDateString('en-AU');
    }

    return { ...registration, ...newProp };
  },
};

export default {
  namespaced: true,

  state: {
    filterStatus: null,
    registrations: [],
    registration: {},
    isLoadingRegistrations: false,
  },
  getters: {
    registrations(state, getters, rootState, rootGetters) {
      return state.registrations.map((r) => helper.mapRegistration(r, rootGetters['auth/voterUsers'].length));
    },
    registration(state, getters, rootState, rootGetters) {
      return helper.mapRegistration(state.registration, rootGetters['auth/voterUsers'].length);
    },
    isLoadingRegistrations(state) {
      return state.isLoadingRegistrations;
    },
  },
  actions: {
    initialize({ commit }) {
      //cached auth user/token
      commit('setFilterStatus', null);
      commit('setRegistrations', []);
      commit('setRegistration', {});
      commit('setIsLoadingRegistrations', false);
    },
    setFilterStatus({ commit }, status) {
      return new Promise((resolve) => {
        commit('setFilterStatus', status);
        resolve(status);
      });
    },
    getRegistrations({ commit, dispatch }, status) {
      commit('setIsLoadingRegistrations', true);
      let mapStatus = status;
      switch (status) {
        case 'Verification':
          mapStatus = 'Submitted';
          break;
        case 'Pending':
          mapStatus = 'Verified';
          break;
      }
      return new Promise((resolve, reject) => {
        VotingRegistrationsService.getVotingRegistrations(mapStatus)
          .then((registrations) => {
            commit('setRegistrations', registrations);
            //renew token
            dispatch('auth/refreshToken', null, { root: true });
            resolve(registrations);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            commit('setIsLoadingRegistrations', false);
          });
      });
    },
    getRegistration({ commit, dispatch }, id) {
      return new Promise((resolve) => {
        VotingRegistrationsService.getVotingRegistration(id).then((registration) => {
          commit('setRegistration', registration);
          //renew token
          dispatch('auth/refreshToken', null, { root: true });

          resolve(registration);
        });
      });
    },
    verifyRegistration({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        VotingRegistrationsService.verifyRegistration(id)
          .then((registration) => {
            commit('setRegistration', registration);
            //renew token
            dispatch('auth/refreshToken', null, { root: true });

            resolve(registration);
          })
          .catch((error) => {
            console.warn('catch error', error);
            if (error.response?.data) {
              reject(error.response.data);
            } else {
              reject(error);
            }
          });
      });
    },
    approveRegistration({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        VotingRegistrationsService.approveRegistration(id)
          .then((registration) => {
            commit('setRegistration', registration);
            //renew token
            dispatch('auth/refreshToken', null, { root: true });

            resolve(registration);
          })
          .catch((error) => {
            console.warn('catch error', error);
            if (error.response?.data) {
              reject(error.response.data);
            } else {
              reject(error);
            }
          });
      });
    },
    denyRegistration({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        VotingRegistrationsService.denyRegistration(id)
          .then((registration) => {
            commit('setRegistration', registration);
            //renew token
            dispatch('auth/refreshToken', null, { root: true });

            resolve(registration);
          })
          .catch((error) => {
            console.warn('catch error', error);
            if (error.response?.data) {
              reject(error.response.data);
            } else {
              reject(error);
            }
          });
      });
    },
  },
  mutations: {
    setFilterStatus(state, status) {
      state.filterStatus = status;
    },
    setRegistrations(state, registrations) {
      state.registrations = registrations;
    },
    setRegistration(state, registration) {
      state.registration = registration;
    },
    setIsLoadingRegistrations(state, value) {
      state.isLoadingRegistrations = !!value;
    },
  },
};
